import React from 'react';
import styled from 'styled-components';
import {Button} from '../../atoms/Buttons/Button';
import {Icon} from '../../atoms/Icon/Icon';
import {GenericIconName} from '../../atoms/Icon/IconName';

type direction = 'prev' | 'next';

interface NavProps {
  direction: direction;
  onClick: () => void;
  'aria-label'?: string;
}

export const NavButton: React.FC<NavProps> = ({
  onClick,
  direction,
  'aria-label': ariaLabel,
}) => {
  return (
    <StyledNavButton
      onClick={onClick}
      aria-label={ariaLabel}
      variant="secondary"
      size="fit-width"
    >
      <Icon
        size="S"
        asset={
          direction === 'prev'
            ? GenericIconName.ArrowLeft
            : GenericIconName.ArrowRight
        }
      />
    </StyledNavButton>
  );
};

const StyledNavButton = styled(Button)`
  &&& {
    border: none;
    padding: 20px;
    box-shadow: none;
    height: auto;
  }
`;
